import { TextField, Typography } from '@material-ui/core';
import { useState } from 'react';
import { Form } from '../../../components/Form';
import { FormField } from '../../../components/Form/FormField';
import { FormSubmitButton } from '../../../components/Form/FormSubmitButton';
import { LinkExternal } from '../../../components/LinkExternal';
import { Centered } from '../../../layout/Centered';
import { FlexContainer, FlexItem } from '../../../layout/Flex';
import { Page } from '../../../layout/Page';
import { callFirebaseFunction } from '../../../services/firebaseFunctions';

export const PageLinkShortener = () => {
  const [shortUrl, setShortUrl] = useState('');
  return (
    <Page width="M">
      <Form
        initalValues={{ url: '' }}
        onSubmit={(values) =>
          callFirebaseFunction<{ url: string }>('shortener-shorten', {
            url: values.url
          }).then((res) => setShortUrl(res.url))
        }
      >
        {({ submitting, values }) => (
          <FlexContainer fullWidth>
            <FlexItem flex={1}>
              <FormField<string> name="url">
                {({ input }) => <TextField {...input} fullWidth autoFocus />}
              </FormField>
            </FlexItem>
            <FormSubmitButton
              submitComponent="Shortening..."
              submitting={submitting}
              variant="contained"
              disabled={!values.url || !values.url.startsWith('http')}
              color="primary"
            >
              Shorten
            </FormSubmitButton>
          </FlexContainer>
        )}
      </Form>

      {shortUrl && (
        <Centered height={200}>
          <Typography variant="h3">
            <LinkExternal href={shortUrl} color="primary" />
          </Typography>
        </Centered>
      )}
    </Page>
  );
};
